import { useSelectors } from '@exodus/headless-react';
import { useSelector } from 'react-redux';
const useExchangeBalance = (params) => {
    const { assetName, walletAccount } = params;
    const selectors = useSelectors();
    const asset = useSelector(selectors.assets.createAssetSelector(assetName));
    const spendableBalance = useSelector(selectors.balances.getSpendable)({
        assetName,
        walletAccount,
    });
    if (!spendableBalance) {
        return asset.currency.ZERO;
    }
    return spendableBalance;
};
export default useExchangeBalance;
